export const vessels = ({ app }) => app.vessels;
export const shipyards = ({ app }) => app.shipyards;
export const drydocks = ({ app }) => app.drydocks;
export const selectedRoute = ({ app }) => app.selectedRoute;
export const isLoading = ({ app }) => app.isLoading;
export const hasEditRights = ({ app }) => app.hasEditRights;
export const loadingState = ({ app }) => app.loadingState;
